import { useEffect } from "react"

const useTitle = title => {
    useEffect(() => {
        document.title = `${title}- Drop-Shipping`;
    }, [title])
}

export default useTitle;